module.exports = __webpack_public_path__ + "img/kleisma4m-m@2.dfe85ca6.jpg";